import styled from "styled-components";

export const StatusTagStyled = styled.div`
  display: inline-flex;

  .tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 20px;
    border: 1px solid ${({ $bg }) => $bg};
    background: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
    min-width: ${({ $width }) => $width};
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    white-space: nowrap;
    box-sizing: border-box;
  }

  .dot {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

`;
